import React, { useState, useEffect, useContext } from 'react';
import { CustomRegistrationQuestion, EventSelectedRegistrationQuestion } from '../types/RegistrationQuestion';
import { EventInstrument } from '../types/Instrument';
import { getEventInstruments } from '../services/eventInstrumentService';
import { EventContext } from '../context/EventContext';

// Define the types based on your `eventSelectedRegistrationQuestion`
interface RegistrationCustomQuestionComponentProps {
  question: CustomRegistrationQuestion;
  onCustomAnswer: (id: string, value: string | number) => void;
  customAnswer?: string | number;
  event_id: string | null;
}

export const RegistrationCustomQuestionComponent: React.FC<RegistrationCustomQuestionComponentProps> = ({
  question,
  onCustomAnswer,
  customAnswer = '',
  event_id,
}) => {
  const [userAnswer, setUserAnswer] = useState<string | number>(customAnswer); // Answer state
  const [showDescription, setShowDescription] = useState<boolean>(false); // Show description state
  const genders = ['Male', 'Female', 'Non-binary', 'Other'];
  const [instruments, setInstruments] = useState<EventInstrument[]>([]);

  const audio = 'audio/*';
  const video = 'video/*';
  const image = 'image/*';
  const document = '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,';
  

  useEffect(() => {
    setUserAnswer(customAnswer);
  }, [customAnswer]);

  useEffect(() => {
    const fetchInstruments = async () => {
      if (event_id) {
        const eventInstruments = await getEventInstruments(event_id);
        setInstruments(eventInstruments);
      }
    };
    fetchInstruments();
  }, [event_id]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { type, value } = e.target;
  
    // if (type === 'file') {
    //   // Ensure that e.target is an HTMLInputElement before accessing 'files'
    //   const inputElement = e.target as HTMLInputElement;
    //   if (inputElement.files) {
    //     const file = inputElement.files[0];  // Get the first file
    //     setUserAnswer(file);  // Store the file in state (or process as needed)
    //     onAnswer(question.event_selected_registration_question_id, file); // Send file to parent
    //   }
    // } else {
      // Handle regular inputs (text, select, etc.)
      setUserAnswer(value);  // Store the string value
      onCustomAnswer(question.custom_registration_question_id, value); // Send answer to parent
    // }
  };

  const renderInputField = () => {

              return (<input
                type="text"
                value={typeof userAnswer === 'string' ? userAnswer : ''}
                onChange={handleChange}
                required={question.is_required}
                placeholder=''
                maxLength={250}
              />);
  
 };


  return (
    <div style={{ marginBottom: '20px' }}>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <label>
          <strong>{question.custom_question_text}</strong>
          {(question.is_required == true) && <span style={{ color: 'red' }}> *</span>}
        </label>

        {/* Input field along with info button and description */}
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <div style={{ width: '100%', maxWidth: '500px' }}>{renderInputField()}</div>

          {/* Show Info button and description */}
          {/* {question.description && (
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '5px' }}>
              <button
                type="button"
                onClick={() => setShowDescription((prev) => !prev)}
                style={{
                  background: 'none',
                  color: 'blue',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  padding: '5px',
                }}
              >
                {showDescription ? 'Hide Info' : 'Show Info'}
              </button>
              {showDescription && <p style={{ marginLeft: '10px', display: 'inline-block' }}>{question.description}</p>}
            </div>
          )} */}
        </div>
      </div>
    </div>
  );
};
